/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

import * as util from 'assets/js/util'
const debug = process.env.NODE_ENV !== 'production'
const state = {
  course: {},
  userInfo: util.cookieOperate.getUserInfo() || null,
  productGuid: 'a5c72d76-16dc-4bb6-b6af-f2e562b1839b',
  systemInfo: null,
  thirdParty: '',
  authorToken: util.cookieOperate.getAuthorToken() || '',
  thirdPartyInfo: {
    'weixin': null,
    'qq': null,
    'sina': null
  },
  beforeLoginPage: util.cookieOperate.getBeforeLoginPage() || '/info',
  orderInfo: util.cookieOperate.getOrderInfo() || null,
  orderInquireState: util.cookieOperate.getOrderInquireState() || null,
  orderVTime: util.cookieOperate.getOrderVTime() || null,
  bannerState: util.cookieOperate.getBannerState() || null,
  backgoFile: '' // 上一步存储信息
}

export default state




// WEBPACK FOOTER //
// ./src/store/state.js